import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/src/js/ui/photoswipe-ui-default'
import uuidv4 from 'uuid/v4'

/**
 * PhotoSwipe初期化
 * @param {HTMLElement} galleryEl ギャラリーのルート要素
 */
export default function initPhotoSwipeFromDOM(galleryEl) {
  galleryEl.setAttribute('data-pswp-uid', uuidv4())
  galleryEl.addEventListener('click', onThumbnailsClick)

  const hashData = photoswipeParseHash()
  if (hashData.pid && hashData.gid) {
    openPhotoSwipe(hashData.pid, galleryEl, true, true)
  }
}

function parseThumbnailElements(el) {
  const thumbElements = Array.prototype.slice.call(
    el.querySelectorAll('figure')
  )

  const numNodes = thumbElements.length
  const items = []
  for (let i = 0; i < numNodes; i++) {
    const figureEl = thumbElements[i]
    if (figureEl.nodeType !== 1) {
      continue
    }
    const linkEl = figureEl.children[0]
    const size = linkEl.getAttribute('data-size').split('x')
    const item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10),
      title: linkEl.getAttribute('title')
    }
    if (figureEl.children.length > 1) {
      item.title = figureEl.children[1].innerHTML
    }
    if (linkEl.children.length > 0) {
      item.msrc = linkEl.children[0].getAttribute('src')
    }
    item.el = figureEl
    items.push(item)
  }
  return items
}

function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn))
}

function onThumbnailsClick(e) {
  e = e || window.event
  e.preventDefault ? e.preventDefault() : e.returnValue = false
  const eTarget = e.target || e.srcElement

  const clicked = closest(eTarget, (el) => {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE')
  })

  if (!clicked) {
    return
  }

  // figure -> li -> ul
  const gallery = clicked.parentNode.parentNode

  const index = Array.prototype.findIndex.call(
    gallery.childNodes, // all lists
    node => node.nodeType === 1 ? (node === clicked.parentNode) : false
  )

  if (index >= 0) {
    openPhotoSwipe(index, gallery)
  }

  return false
}

function photoswipeParseHash() {
  const hash = window.location.hash.substring(1)
  const params = {}
  if (hash.length < 5) {
    return params
  }
  let vars = hash.split('&')
  for (let i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue
    }
    let pair = vars[i].split('=')
    if (pair.length < 2) {
      continue
    }
    params[pair[0]] = pair[1]
  }
  if (params.gid) {
    params.gid = parseInt(params.gid, 10)
  }
  return params
}

function openPhotoSwipe(index, galleryElement, disableAnimation, fromURL) {
  let pswpElement = document.getElementById('pswp')

  const items = parseThumbnailElements(galleryElement)

  const options = {
    captionEl: false,
    shareEl: false,
    fullscreenEl: false,
    showHideOpacity: true,
    bgOpacity: 0.8,
    barsSize: { top: 0, bottom: 'auto' },
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),
    getThumbBoundsFn: index => {
      const thumbnail = items[index].el.getElementsByTagName('img')[0]
      const pageYScroll = window.pageYOffset || document.documentElement.scrollTop
      const rect = thumbnail.getBoundingClientRect()
      return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
    }
  }

  if (fromURL) {
    if (options.galleryPIDs) {
      for (let j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j
          break
        }
      }
    } else {
      options.index = parseInt(index, 10) - 1
    }
  } else {
    options.index = parseInt(index, 10)
  }

  if (isNaN(options.index)) {
    return
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0
  }

  const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
  gallery.init()
}
